function Skills() {
    return (
      <>
        <h2>Skills</h2>
        <table id="skills">
          <tr>
            <td>
              <p>
                <strong>Languages: </strong> Python, R, JavaScript/TypeScript,
                Java, SQL, HTML, CSS, C++, LaTeX
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>Frameworks and Libraries: </strong> React, Svelte,
                Django, D3, pandas, tidyverse, scikit-learn, Plotly & Plotly-Dash, Seaborn
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <strong>Tools and Technologies: </strong> JetBrains IDEs, VS
                Code, Jupyter Notebook, AWS (Glue, Lambda, IAM, S3,
                Cloudformation), Figma, Git, Docker
              </p>
            </td>
          </tr>
        </table>
      </>
    );
}

export default Skills;